export default function apiURLs(state = {}, action = {}) {
  let url = action.url || (action.data || {}).url
  let urls = state.urls || []

  if (url && urls.indexOf(url) == -1) {
    urls = urls.concat(url)
  }

  return Object.assign({}, state, { urls })
}



/** WEBPACK FOOTER **
 ** ../app/reducers/apiUrls.js
 **/